import { Component } from 'preact'
// eslint-disable-next-line import/no-internal-modules
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@insided/deprecated-preact-components/modal'
import Button from '@insided/control/uikit/Button'

export interface CreateSegmentModalProps {
  onClose: () => void
  showModal: boolean
}

class CreateSegmentModal extends Component<CreateSegmentModalProps> {
  onConfirm = () => {
    window.location.assign('/users/overview')
  }

  render() {
    const { onClose, showModal } = this.props

    return (
      <Modal isOpen={showModal} size='medium'>
        <ModalHeader title='Creating segments' onClose={onClose} />
        <ModalBody>
          <p>You can create a new segment by applying filters to the User Overview and saving that as a segment.</p>
        </ModalBody>
        <ModalFooter>
          <Button title='Take me there' variant='primary' onClick={this.onConfirm} size='medium' />
          <Button title='Cancel' onClick={onClose} size='medium' />
        </ModalFooter>
      </Modal>
    )
  }
}

export default CreateSegmentModal
